import { Copy, Flex, Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export interface IHeadingAndValuesProps {
  heading: string;
  values: string[];
}

export function HeadingAndValues({
  heading: header,
  values,
}: IHeadingAndValuesProps): JSX.Element {
  return (
    <Stack y="md">
      <Stack y="x-sm">
        <Heading variant="h5">{header}</Heading>
      </Stack>
      <Flex flexDirection="column">
        {values.map((value) => (
          <Copy key={value} variant="body">
            {value}
          </Copy>
        ))}
      </Flex>
    </Stack>
  );
}
